import Main from '@/views/common/main'
// 风控
export default [
    //'风控管理'
    {
        path: '/appConfig',
        name: 'appConfig',
        meta: {
            icon: 'ios-apps',
            title: 'APP配置'
        },
        component: Main,
        children: [
            // 游戏路由配置
            {
                path: 'GameRouteConfig',
                name: 'appConfig_GameRouteConfig',
                meta: { title: '游戏路由配置' },
                component: () => import('@/views/appConfig/GameRouteConfig.vue')
            }
        ]
    }
]
// 数据报表
